import React from "react";
import { FiCheck } from "react-icons/fi";

const BrandLogo = props => {
    const classes = "brandName " + props.customClasses;

    return (
        <React.Fragment>
            <div className="brandLogo">
                {props.brand.logo && (
                    <img src={props.brand.logo_path} alt={props.brand.title} />
                )}
                <span className="checked">
                    <FiCheck />
                </span>
            </div>
            <div className={classes}> {props.brand.title}</div>
        </React.Fragment>
    );
};

export default BrandLogo;



// WEBPACK FOOTER //
// ./src/components/Admin/Order/BrandLogo.js